import { CalendarIcon } from '@icon/index';
import { DatePicker } from '@library/datepicker';
import { PageHeading, PageTemplate } from 'modules/shared/features/content';
import moment from 'moment';
import { useState } from 'react';
import ScheduledReportsList from 'modules/analytics/components/ScheduledReportsList/ScheduledReportsList';
import useScheduledReportsListData from 'modules/analytics/hooks/useProgressReportsListData';
import { Label } from '@hyperflake/react-ui-library';

const ScheduledReportsPage = () => {
    const [startDate, setStartDate] = useState(moment().startOf('day'));
    const [endDate, setEndDate] = useState(moment().endOf('day'));

    const formattedStart = startDate.format('YYYY-MM-DD');
    const formattedEnd = endDate.format('YYYY-MM-DD');

    const { data: reports, isLoading } = useScheduledReportsListData(formattedStart, formattedEnd);

    return (
        <PageTemplate>
            <PageHeading className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                <div className="">Scheduled Reports</div>

                <div className="flex w-full flex-col gap-3 sm:w-auto sm:flex-row sm:items-end sm:gap-4">
                    {/* From Date */}
                    <div className="w-full sm:w-auto">
                        <Label className="mb-1 block text-sm">From Date</Label>
                        <div className="relative flex items-center">
                            <DatePicker
                                className="w-full rounded-lg px-4 py-2 pl-12 font-medium text-sm bg-transparent border border-grayscale-300 placeholder:text-grayscale-400 focus:border-primary focus:outline focus:outline-2 focus:outline-primary/10"
                                value={startDate.toDate()}
                                maxDate={endDate.toDate()}
                                onChange={(date) => {
                                    const newStart = moment(date).startOf('day');
                                    setStartDate(newStart);
                                    if (newStart.isAfter(endDate)) setEndDate(newStart.endOf('day'));
                                }}
                            />
                            <CalendarIcon className="absolute left-4 pointer-events-none" />
                        </div>
                    </div>

                    {/* To Date */}
                    <div className="w-full sm:w-auto">
                        <Label className="mb-1 block text-sm">To Date</Label>
                        <div className="relative flex items-center">
                            <DatePicker
                                className="w-full rounded-lg px-4 py-2 pl-12 font-medium text-sm bg-transparent border border-grayscale-300 placeholder:text-grayscale-400 focus:border-primary focus:outline focus:outline-2 focus:outline-primary/10"
                                value={endDate.toDate()}
                                minDate={startDate.toDate()}
                                onChange={(date) => {
                                    const newEnd = moment(date).endOf('day');
                                    setEndDate(newEnd);
                                    if (newEnd.isBefore(startDate)) setStartDate(newEnd.startOf('day'));
                                }}
                            />
                            <CalendarIcon className="absolute left-4 pointer-events-none" />
                        </div>
                    </div>
                </div>
            </PageHeading>

            <div>
                <ScheduledReportsList isLoading={isLoading} reports={reports} />
            </div>
        </PageTemplate>
    );
};

export default ScheduledReportsPage;
